import { Component, inject, OnDestroy, OnInit, signal } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import {
  IActivo,
  IDespacho,
  IQueryParam,
  IRecorrido,
  IUpdateDespacho,
  IUsuario,
} from 'modelos/src';
import { firstValueFrom, Subscription } from 'rxjs';
import { FormControl, FormGroup } from '@angular/forms';
import { DialogService } from '../../../../../auxiliares/dialog/dialog.service';
import { DespachosService } from '../despachos.service';
import { HelperService } from '../../../../../auxiliares/servicios/helper.service';
import { Lista2Service } from '../../../../../auxiliares/servicios/lista2.service';

@Component({
  selector: 'app-editar-despacho',
  templateUrl: './editar-despacho.component.html',
  styleUrl: './editar-despacho.component.scss',
  standalone: false,
})
export class EditarDespachoComponent implements OnInit, OnDestroy {
  private lista2 = inject(Lista2Service);
  private dialog = inject(DialogService);
  private service = inject(DespachosService);
  private helper = inject(HelperService);

  private id = inject(MAT_DIALOG_DATA) as string;
  readonly dialogRef = inject(MatDialog);
  public loading = signal(false);

  public despacho?: IDespacho;

  public vehiculos: IActivo[] = [];
  public vehiculos$?: Subscription;

  public choferes: IUsuario[] = [];
  public choferes$?: Subscription;

  public recorridos: IRecorrido[] = [];
  public recorridos$?: Subscription;

  public form?: FormGroup;

  private createForm() {
    this.form = new FormGroup({
      salio: new FormControl(this.despacho?.salio),
      idActivo: new FormControl(this.despacho?.idActivo),
      idChofer: new FormControl(this.despacho?.idChofer),
      idsRecorridos: new FormControl(this.despacho?.idsRecorridos),
      completado: new FormControl(false),
      cancelado: new FormControl(this.despacho?.cancelado || false),
      idCronograma: new FormControl(this.despacho?.idCronograma),
    });
  }

  private async listar() {
    this.despacho = await firstValueFrom(this.lista2.despacho(this.id));
  }

  // Vehículos
  private async listarVehiculos() {
    const query: IQueryParam = {
      sort: 'identificacion',
      limit: 0,
      select: 'identificacion vehiculo.patente',
    };
    this.vehiculos$?.unsubscribe();
    this.vehiculos$ = this.lista2.vehiculos(query, 30).subscribe((data) => {
      this.vehiculos = data.datos;
    });
  }
  // Choferes
  private async listarChoferes() {
    const query: IQueryParam = {
      sort: 'datosPersonales.nombre',
      limit: 0,
      select: 'datosPersonales roles identificacionInterna',
    };
    this.choferes$?.unsubscribe();
    this.choferes$ = this.lista2.chofers(query, 30).subscribe((data) => {
      this.choferes = data.datos;
    });
  }
  // Recorridos
  private async listarRecorridos() {
    const query: IQueryParam = {
      sort: 'nombre',
      limit: 0,
      select: 'nombre nombreFlota destino por',
    };
    this.recorridos$?.unsubscribe();
    this.recorridos$ = this.lista2.recorridos(query, 30).subscribe((data) => {
      this.recorridos = data.datos;
    });
  }

  public async editar() {
    const res = await this.dialog.confirm(
      'Editar',
      '¿Querés editar el despacho?',
    );
    if (!res) return;
    try {
      this.loading.set(true);
      const data = this.form?.value as IUpdateDespacho;
      await this.service.update(this.id, data);
      this.helper.notifSuccess('Despacho editado correctamente');
      this.dialogRef.closeAll();
    } catch (error) {
      console.error(`Error al editar despacho`, error);
      this.helper.notifError(error);
    } finally {
      this.loading.set(false);
    }
  }

  async ngOnInit() {
    this.loading.set(true);
    await Promise.all([
      this.listar(),
      this.listarVehiculos(),
      this.listarChoferes(),
      this.listarRecorridos(),
    ]);
    this.createForm();
    this.loading.set(false);
  }

  ngOnDestroy(): void {
    this.vehiculos$?.unsubscribe();
    this.choferes$?.unsubscribe();
    this.recorridos$?.unsubscribe();
  }
}
